// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"f7f0e134","344":"d156988d","629":"1671babc"}[chunkId] + ".chunk.css";
};